// extracted by mini-css-extract-plugin
export default {"tree":"Tree_tree__LJsHJ","dark":"Tree_dark__JHpPJ"};